export const COUNTRY_ISO_2_NAME: { [key: string]: string } = {
  AE: "United Arab Emirates",
  AU: "Australia",
  AR: "Argentina",
  AT: "Austria",
  BA: "Bosnia and Herzegovina",
  BD: "Bangladesh",
  BE: "Belgium",
  BG: "Bulgaria",
  BH: "Bahrain",
  BM: "Bermuda",
  BR: "Brazil",
  BW: "Botswana",
  CA: "Canada",
  CH: "Switzerland",
  CL: "Chile",
  CN: "China",
  CO: "Colombia",
  CR: "Costa Rica",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DE: "Germany",
  DK: "Denmark",
  EE: "Estonia",
  EG: "Egypt",
  ES: "Spain",
  FI: "Finland",
  FR: "France",
  GB: "United Kingdom",
  GH: "Ghana",
  GR: "Greece",
  HK: "Hong Kong",
  HR: "Croatia",
  HU: "Hungary",
  ID: "Indonesia",
  IE: "Ireland",
  IL: "Israel",
  IN: "India",
  IS: "Iceland",
  IT: "Italy",
  JM: "Jamaica",
  JO: "Jordan",
  JP: "Japan",
  KE: "Kenya",
  KR: "South Korea",
  KW: "Kuwait",
  KZ: "Kazakhstan",
  LA: "Laos",
  LB: "Lebanon",
  LK: "Sri Lanka",
  LT: "Lithuania",
  LU: "Luxembourg",
  LV: "Latvia",
  MA: "Morocco",
  ME: "Montenegro",
  MK: "Macedonia",
  MN: "Mongolia",
  MT: "Malta",
  MU: "Mauritius",
  MX: "Mexico",
  MY: "Malaysia",
  NA: "Namibia",
  NG: "Nigeria",
  NL: "Netherlands",
  NO: "Norway",
  NZ: "New Zealand",
  OM: "Oman",
  PA: "Panama",
  PE: "Peru",
  PH: "Philippines",
  PK: "Pakistan",
  PL: "Poland",
  PS: "Palestine",
  PT: "Portugal",
  QA: "Qatar",
  RO: "Romania",
  RS: "Serbia",
  RU: "Russia",
  SA: "Saudi Arabia",
  SE: "Sweden",
  SG: "Singapore",
  SI: "Slovenia",
  SK: "Slovakia",
  TH: "Thailand",
  TN: "Tunisia",
  TR: "Turkey",
  TW: "Taiwan",
  TZ: "Tanzania",
  UA: "Ukraine",
  US: "United States",
  VE: "Venezuela",
  VN: "Vietnam",
  ZA: "South Africa",
  EU: " Europe",
};

export const COUNTRY_ISO_2_NAME_JA: { [key: string]: string } = {
  AE: "アラブ首長国連邦",
  AU: "オーストラリア",
  AR: "アルゼンチン",
  AT: "オーストリア",
  BA: "ボスニア・ヘルツェゴビナ",
  BD: "バングラデシュ",
  BE: "ベルギー",
  BG: "ブルガリア",
  BH: "バーレーン",
  BM: "バミューダ",
  BR: "ブラジル",
  BW: "ボツワナ",
  CA: "カナダ",
  CH: "スイス",
  CL: "チリ",
  CN: "中国",
  CO: "コロンビア",
  CR: "コスタリカ",
  CY: "キプロス",
  CZ: "チェコ",
  DE: "ドイツ",
  DK: "デンマーク",
  EE: "エストニア",
  EG: "エジプト",
  ES: "スペイン",
  FI: "フィンランド",
  FR: "フランス",
  GB: "イギリス",
  GH: "ガーナ",
  GR: "ギリシャ",
  HK: "香港",
  HR: "クロアチア",
  HU: "ハンガリー",
  ID: "インドネシア",
  IE: "アイルランド",
  IL: "イスラエル",
  IN: "インド",
  IS: "アイスランド",
  IT: "イタリア",
  JM: "ジャマイカ",
  JO: "ヨルダン",
  JP: "日本",
  KE: "ケニア",
  KR: "韓国",
  KW: "クウェート",
  KZ: "カザフスタン",
  LA: "ラオス人民民主共和国",
  LB: "レバノン",
  LK: "スリランカ",
  LT: "リトアニア",
  LU: "ルクセンブルク",
  LV: "ラトビア",
  MA: "モロッコ",
  ME: "モンテネグロ",
  MK: "マケドニア",
  MN: "モンゴル",
  MT: "マルタ",
  MU: "モーリシャス",
  MX: "メキシコ",
  MY: "マレーシア",
  NA: "ナミビア",
  NG: "ナイジェリア",
  NL: "オランダ",
  NO: "ノルウェー",
  NZ: "ニュージーランド",
  OM: "オマーン",
  PA: "パナマ",
  PE: "ペルー",
  PH: "フィリピン",
  PK: "パキスタン",
  PL: "ポーランド",
  PS: "パレスチナ",
  PT: "ポルトガル",
  QA: "カタール",
  RO: "ルーマニア",
  RS: "セルビア",
  RU: "ロシア連邦",
  SA: "サウジアラビア",
  SE: "スウェーデン",
  SG: "シンガポール",
  SI: "スロベニア",
  SK: "スロバキア",
  TH: "タイ",
  TN: "チュニジア",
  TR: "トルコ",
  TW: "台湾",
  TZ: "タンザニア",
  UA: "ウクライナ",
  US: "アメリカ合衆国",
  VE: "ベネズエラ",
  VN: "ベトナム",
  ZA: "南アフリカ",
  EU: "ヨーロッパ",
};

export const COUNTRY_TICKER_2_LINK: { [key: string]: string } = {
  "GT10:GOV": "rates-bonds/government-bonds/us",
  "GTGBP10Y:GOV": "rates-bonds/government-bonds/uk",
  "GTDEM10Y:GOV": "rates-bonds/government-bonds/germany",
  "GTJPY10Y:GOV": "rates-bonds/government-bonds/japan",
  "GTAUD10Y:GOV": "rates-bonds/government-bonds/australia",
};
